import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { TranslateService } from '@ngstack/translate';
import { SubsidiaryStudentService } from 'src/app/services/http/business/subsidiary/dashboard/subsidiary-student.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatSelect } from '@angular/material';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { IBranch } from 'src/app/interfaces/branch';
import { IPlacementType } from 'src/app/interfaces/placementType';
//import { BIDService } from 'src/app/services/common/bid.service';
import { PlacementTypeService } from 'src/app/services/http/business/placement/placement-type.service';
import { BranchService } from 'src/app/services/http/business/branch/branch.service';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { ILevelInfo } from 'src/app/interfaces/levelInfo';
import { LevelInfoService } from 'src/app/services/http/business/levelInfo/level-info.service';
//import { ContractService } from 'src/app/services/http/business/contract/contract.service';
import { environment } from 'src/environments/environment';
import * as moment from "jalali-moment";
import { SubsidiaryPlacementService } from 'src/app/services/http/business/subsidiary/subsidiary-placement.service';
import { BIDService } from 'src/app/services/common/bid.service';
import { IError } from 'src/app/interfaces/error.interface';

// import { SoundEnum } from 'src/app/enums/sound.enum';
const userInfo = JSON.parse(localStorage.getItem("userInfo"));
@Component({
  selector: 'app-subsidiary-placement-entry',
  templateUrl: './subsidiary-placement-entry.component.html',
  styleUrls: ['./subsidiary-placement-entry.component.css']
})
export class SubsidiaryPlacementEntryComponent implements OnInit {

  form: FormGroup;
  branchList: IBranch[];
  branchEncryptId: string;
  placementTypeId: number;
  errors = new Array();
  placementTypeList: IPlacementType[];
  errObject: any;
  param: any;
  errorList: IError[] = [];
  placementInCompanyList = [];
  levelInfoList: ILevelInfo;

  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    private branchService: BranchService,
    private levelInfoService: LevelInfoService,
    private bidService: BIDService,
    //private contractService: ContractService,
    private placementTypeService: PlacementTypeService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    public subsidiaryStudentService: SubsidiaryStudentService,
    public subsidiaryPlacementService: SubsidiaryPlacementService,
    private dialogRef: MatDialogRef<SubsidiaryPlacementEntryComponent>,

    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {
    console.log(this.data);

    this.createForm();
    // this.getListPlacementInCompany();
    //this.getBranchList();
    this.getAghBranchInCompany()
  }
  createForm() {
    this.form = this.fb.group({
      CanAddAndReplace: [true],

      UserEncryptId: [userInfo.UserEncryptId,
      Validators.compose([Validators.required])
      ],
      PlacementTypeId: [null,
        Validators.compose([Validators.required])
      ],

      LevelId: [null, Validators.compose([Validators.required])
      ],

      ThatDate: [
        null,
        Validators.compose([
          Validators.required,
        ])
      ],
      TimeReserved: [""],

      CustomerContractPersonNationalCodeId: [
        this.data.Id,
        Validators.compose([
          Validators.required
        ])
      ],
    });
  }

  // getListPlacementInCompany() {

  //   this.contractService.getListPlacementInCompany().subscribe(
  //     res => {
  //       this.placementInCompanyList = res.DataList;
  //     },
  //     err => {
  //       console.log(err);

  //     }
  //   );
  // }

  getBranchList() {
    this.branchService.listByLogin(0, 0).subscribe(
      res => {
        this.branchList = res.DataList;
        // this.hidePlacementType = false;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getAghBranchInCompany() {
    this.branchService.getAghBranchInCompany().subscribe(res => {
      this.bidService.setBID(res.BranchEncryptId);
      this.loadPlacementType();
    });
  }

  loadPlacementType() {
    this.placementTypeService.list(0, 0).subscribe(
      re => {
        this.placementTypeList = re.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }
  getLevelInfo(e: MatSelect) {

    this.form.controls['PlacementTypeId'].setValue(e.value.Id);

    this.levelInfoService.getList(e.value.PackageId).subscribe(
      res => {
        this.levelInfoList = res.DataList;
      },
      err => {
        console.log(err);

      }
    );
  }

  async validationValue(params: any) {
    this.errors = new Array();
    let result: boolean;
    await this.subsidiaryPlacementService.placementCheck(params).subscribe(() => {

      result = true;
      return result
    }, err => {
      // this.errObject = this.errorService.getError(err);
      // this.param = this.errorService.objectError(this.errObject);
      // this.errors = this.errorService.returnError(err);
      result = false;
      this.errorList = this.errorService.getErrorList(err.error)
      return result
    });
    return result;
  }

  setDefaulteTime() {
    let data = new Date();
    return data.getHours() + ":" + data.getMinutes() + ":00";
  }

  submit(form: any) {
    this.errors = new Array();
    form.ThatDate = moment
      .from(form.ThatDate, "en")
      .utc(true)
      .format(environment.dateFormat);

    form.TimeReserved = this.setDefaulteTime();

    if (this.validationValue(form)) {
      this.subsidiaryPlacementService.addPlacement(form).subscribe(() => {

        this.snackBar.OpenSnackBar(
          this.translate.get("success.placementsave"),
          "ok",
          3000,
          SoundEnum.beep
        );
        this.onNoClick();
      },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error)
        });
    }
  }
  onNoClick() {
    this.dialogRef.close();
  }
}
